import Axios from "axios";
const http = Axios.create({
  baseURL: "/",
  timeout: 15000
});

http.interceptors.response.use(
  response => {
    return Promise.resolve(response);
  },
  error => {
    return Promise.reject(error);
  }
);
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(url, { params: params })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// export default http;
